import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-admin';
import { stringify } from 'query-string';

import { UserIcon } from './index';

const LinkToUsers = ({ record }) => (
  <Button color="primary">
    <Link
      to={{
        pathname: '/users',
        search: stringify({
          order: 'desc',
          sort: 'id',
          page: 1,
          perPage: 10,
          filter: JSON.stringify({ business_id: record.id })
        })
      }}
    >
      <span style={{ position: 'relative', bottom: 7, paddingRight: 3 }}>
        {record.number_of_users}
      </span>
      <UserIcon />
    </Link>
  </Button>
);

LinkToUsers.defaultProps = {
  source: 'number_of_users',
  addLabel: true,
  label: 'Users'
};

export default LinkToUsers;



// WEBPACK FOOTER //
// ./src/users/LinkToUsers.js